import React, { Component } from 'react'
import Load from '../assets/images/load.png'
import Recaptcha from 'react-google-recaptcha'
import { navigate } from 'gatsby'

const RECAPTCHA_KEY = "6Lc_mi0iAAAAAPxvjkOBguy-Y9VKzHpmRV6HIGSi"

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

class Form extends Component {

  state = {
    form: {},
  }

  constructor(props) {
    super(props)
    this.form = React.createRef();
  }

  handleChange = e => {
    let { form } = this.state
    if (e.target.name === 'type') {
      let current = form[e.target.name] || ''
      if (current.indexOf(e.target.value) === -1) {
        // add
        form[e.target.name] = current + ' ' + e.target.value
      } else {
        // remove
        form[e.target.name] = current.replace(' ' + e.target.value, '')
      }
    } else {
      form[e.target.name] = e.target.value
    }
    this.setState({ form })
  }

  handleRecaptcha = value => {
    this.setState({ "g-recaptcha-response": value });
  }

  handleSubmit = async (e) => {
    e.preventDefault()

    if (!this.form.current.checkValidity()) return false

    let sendTo = 'rory@whitefoxrealestate.com.au, marty@whitefoxrealestate.com.au, shura@whitefoxrealestate.com.au, taylor@whitefoxrealestate.com.au'
    if (process.env.GATSBY_LOCATION === 'perth') sendTo = 'perth@whitefoxrealestate.com.au'
    if (process.env.GATSBY_LOCATION === 'adelaide') sendTo = 'adelaide@whitefoxrealestate.com.au'
    if (process.env.GATSBY_LOCATION === 'brisbane') sendTo = 'brisbane@whitefoxrealestate.com.au'
    if (process.env.GATSBY_LOCATION === 'gc') sendTo = 'goldcoast@whitefoxrealestate.com.au'
    if (process.env.GATSBY_LOCATION === 'nz') sendTo = 'marty@whitefoxrealestate.com.au, rory@whitefoxrealestate.com.au, brittany@whitefoxrealestate.co.nz'

    const formData = new FormData(this.form.current)
    formData.append('form-name', this.form.current.getAttribute("name"))
    formData.append("sendTo", sendTo)
    const queryString = new URLSearchParams(formData).toString()

    this.setState({result: 'success'})

    // https://zapier.com/editor/204391002/published/204391003/sample
    await fetch("https://hooks.zapier.com/hooks/catch/2181815/39q03xw/?"+queryString)

  }
  render() {
    
    let props = {
      ref: this.form,
      name: 'contact_page_form',
      onSubmit: this.handleSubmit,
    }

    if (this.state.result === 'success') {

      navigate('/thank-you');
      return (
        <div className="signup__nav">
          <p>Thanks for getting in contact with us.<br /> A member of our team will be in touch soon.</p>
        </div>
      )
    }

    return (
      <div className="signup__nav">
        <form {...props}>
          <p>Looking for something? Find it here. We’ll get back to you shortly.</p>
          <input type='text' className='name' name='name' placeholder='Name' onChange={this.handleChange} required />
          <input type='email' className='email' name='email' placeholder='Email' onChange={this.handleChange} required />
          <input type='text' className='number' name='phone' placeholder='Number' onChange={this.handleChange} required />
          <p>How can we help?</p>
          <ul>
            <li>
              <input id={`contact_checkbox_0`} className='boxes' name='type' type='checkbox' value='Buy' onChange={this.handleChange} />
              <label htmlFor={`contact_checkbox_0`}>Buy</label>
            </li>
            <li>
              <input id={`contact_checkbox_1`} className='boxes' name='type' type='checkbox' value='Sell' onChange={this.handleChange} />
              <label htmlFor={`contact_checkbox_1`}>Sell</label>
            </li>
            <li>
              <input id={`contact_checkbox_2`} className='boxes' name='type' type='checkbox' value='Leasing' onChange={this.handleChange} />
              <label htmlFor={`contact_checkbox_2`}>Leasing</label>
            </li>
            <li>
              <input id={`contact_checkbox_3`} className='boxes' name='type' type='checkbox' value='Property Management' onChange={this.handleChange} />
              <label htmlFor={`contact_checkbox_3`}>Property Management</label>
            </li>
            <li>
              <input id={`contact_checkbox_4`} className='boxes' name='type' type='checkbox' value='Other' onChange={this.handleChange} />
              <label htmlFor={`contact_checkbox_4`}>Other</label>
            </li>
            <li>
              <input id={`contact_checkbox_5`} className='boxes' name='type' type='checkbox' value='Join Newsletter' onChange={this.handleChange} />
              <label htmlFor={`contact_checkbox_5`}>Join Newsletter</label>
            </li>
          </ul>
          <textarea row='6' placeholder='Leave us a message.' name='message' onChange={this.handleChange} />
          <div className='recaptcha__wrapper'>
            <Recaptcha
              ref='recaptcha'
              sitekey={RECAPTCHA_KEY}
              onChange={this.handleRecaptcha}
            />
          </div>
          <button className='contactbtn btn' type='submit'>Contact</button>
        </form>
      </div>  
    )
  }
}

class ContactBody extends Component {

  state = {
    formActive: false,
  }

  render() {
    const { content } = this.props
    let { formActive } = this.state

    return (
      <>
        <section className='contact-body' data-color='#FFF'>
          <div className='contact-body__inner'>
            <div className='contact-body__content' dangerouslySetInnerHTML={{ __html: content }} />
            <button type='button' className='btn' onClick={() => this.setState({ formActive: true })}>
              General Enquiries
            </button>
          </div>
        </section>
        <div className={`${formActive ? 'signup active' : 'signup'}`}>
          <Form />
          <div className="signup__close">
            <button className={ formActive ? 'active' : '' } onClick={() => this.setState({ formActive: false })}>
              <img src={Load} alt="Close sign up form"/>
            </button>
          </div>
        </div>
      </>
    )
  }
}

export default ContactBody
